import {get, set} from 'lodash';
import {validateEmail} from './index';

/**
 *
 * @param {object} formFactory Object with all inputs keys and their attributes
 * @example formFactory = {
 *   userId: {
 *    initial: 0,
 *    fromData: 'merchant.user.id',
 *    toSubmit: 'userInput.id',
 *    required: true,
 *    type: 'number',
 *   },
 *   ...
 * }
 * @returns {object} formState Object with all inputs from formFactory as keys and all initial attributes from
 * formFactory as values
 * @example formState = {
 *   userId : 0,
 *   firstName : '',
 *   ...
 * }
 */
export const initFormState = formFactory => {
  let newInitialState = {};

  Object.entries(formFactory).forEach(([key, value]) => {
    newInitialState[key] = value.initial;
  });

  return newInitialState;
};


/**
 *
 * @param data - Result fo query
 * @param formFactory
 * @returns {object} formState with data values
 */
export const formStateWithData = (data, formFactory) => {
  const newFormState = {};

  Object.entries(formFactory).forEach(([key, value]) => {
    if (value.modifierOnInitial) {
      newFormState[key] = value.modifierOnInitial(get(data, value.fromData));
    } else if (value.fromData) {
      newFormState[key] = get(data, value.fromData);
    } else {
      newFormState[key] = value.initial;
    }
  });

  return newFormState;
};

/**
 *
 * @param formFactory
 * @param formState
 * @returns {boolean} True if the form is valid and ready to submit
 */
export const validateFormState = (formFactory, formState) => {
  Object.entries(formFactory).forEach(([key, value]) => {
    if (value.required) {
      switch (value.type) {
      case 'email':
        if (formState[key] === value.initial || !validateEmail(formState[key])) {
          return false;
        }
        break;
      default:
        if (formState[key] === value.initial) {
          return false;
        }
      }
    }
  });

  return true;
};

export const buildFormToSubmit = (formFactory, formToBuild) => {
  let newFormToSubmit = {};

  Object.entries(formFactory).forEach(([key, value]) => {
    if (value.toSubmit) {
      set(newFormToSubmit, value.toSubmit, value.modifierOnSubmit ? value.modifierOnSubmit(formToBuild[key]) : formToBuild[key]);
    }
  });

  return newFormToSubmit;
};
